
import { computed, defineComponent, onMounted, ref, toRaw, watch } from "vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import { ErrorMessage, Field, Form } from "vee-validate";
import store from "@/store";
import MBloader from "@/components/MBLoader.vue";
import useLocale from "@/core/common/useLocale";

export default defineComponent({
  name: "widget-patient-status",
  components: {
    MBloader,
  },
  setup: function () {
    const store = useStore();
    const { t, currentLocale } = useLocale();

    let consent_status = ref(false);
    let patient_process_status = ref(0);
    let patient_name = ref("");
    let active_class = ref("");
    let ctmstab = ref(false);
    let vtbtab = ref(false);
    let initialtab = ref(false);
    const item_complete = ref("item_complete");
    const item_current = ref("item_current");
    const item_current_complete = ref("item_current_complete");
    const isLoaded = ref<boolean>(false);

    /*onMounted(() => {
      store.dispatch(Actions.GET_PATIENT_PROCESSES, {})
    });*/

    const getPatientValues = () => {
      isLoaded.value = false;
      let pv_raw = store.getters.getPatientValues;
      let process = store.getters.getPatientProcesses;

      ctmstab.value = process.ReleaseCTMSReportPatient ? true : false;
      vtbtab.value = process.ReleaseVTBReportPatient ? true : false;

      let fields = [
        "cancer_type",
        "sex",
        "first_name",
        "patient_s_email",
        "patient_s_phone",
        "zip",
        "birthdate",
      ];

      let c = 0;
      for (const [key, value] of Object.entries(pv_raw)) {
        if (fields.indexOf(key) !== -1 && value != "") {
          c++;
        }
      }
      if (pv_raw.consent_sign && pv_raw.consent_sign == "1") {
        consent_status.value = true;
        patient_name.value = pv_raw.first_name;
      }

      if (c == 7) {
        patient_process_status.value = 2;
      } else if (c < 7) {
        patient_process_status.value = 1;
      }
      if (c == 7 && pv_raw.widget_report_count > 0) {
        patient_process_status.value = 4;
      } else if (
        c == 7 &&
        (pv_raw.widget_report == 0 || pv_raw.widget_report == undefined)
      ) {
        patient_process_status.value = 3;
      }
      if (consent_status.value) {
        patient_process_status.value = 6;
      } else if (c == 7 && !consent_status.value && pv_raw.widget_report > 0) {
        patient_process_status.value = 5;
      }

      if (pv_raw.medical_report_count > 0 && consent_status.value) {
        patient_process_status.value = 8;
      } else if (pv_raw.medical_report_count == 0 && consent_status.value) {
        patient_process_status.value = 7;
      } else if (pv_raw.medical_report_count > 0 && !consent_status.value) {
        patient_process_status.value = 12;
      }

      if (
        pv_raw.medical_report_count > 0 &&
        ctmstab.value &&
        consent_status.value
      ) {
        patient_process_status.value = 10;
      } else if (
        pv_raw.medical_report_count > 0 &&
        !ctmstab.value &&
        consent_status.value
      ) {
        patient_process_status.value = 9;
      }
      isLoaded.value = true;
    };

    /*watch(
      () => store.getters.getPatientProcesses,
      function (sd) {
        let process = toRaw(sd);
        ctmstab.value = process.ReleaseCTMSReportPatient ? true : false
        vtbtab.value = process.ReleaseVTBReportPatient ? true : false

      });
    watch(
      () => store.getters.getPatientValues,
      function (r) {
        let pv_raw = toRaw(r);
        let fields = ["cancer_type","gender","first_name","patient_s_email","patient_s_phone","zip","birthdate"];

        let c = 0;
        for (const [key, value] of Object.entries(pv_raw)) {
          if(fields.indexOf(key) !== -1 && value != ""){
            c++;
          }
        }
        if (pv_raw.consent_sign && pv_raw.consent_sign == "1") {
          consent_status.value = true;
          patient_name.value = pv_raw.first_name;
        }


        if(c == 7){
          patient_process_status.value = 2;
        }else if(c < 7){
          patient_process_status.value = 1;
        }
        if(c == 7 && pv_raw.widget_report_count > 0){
          patient_process_status.value = 4;
        }else if(c == 7 && (pv_raw.widget_report == 0 || pv_raw.widget_report == undefined)){
          patient_process_status.value = 3;
        }
        if(consent_status.value ){
          patient_process_status.value = 6;
        }else if(c == 7 && !consent_status.value && pv_raw.widget_report > 0){
          patient_process_status.value = 5;
        }

        if( pv_raw.medical_report_count > 0  && consent_status.value){
          patient_process_status.value = 8;
        }else if( pv_raw.medical_report_count == 0  && consent_status.value){
          patient_process_status.value = 7;
        }else if(pv_raw.medical_report_count > 0  && !consent_status.value){
          patient_process_status.value = 12;
        }

        if(pv_raw.medical_report_count > 0 && ctmstab.value  && consent_status.value){
          patient_process_status.value = 10;
        }else if(pv_raw.medical_report_count > 0 && !ctmstab.value && consent_status.value){
          patient_process_status.value = 9;
        }

      }
    );*/

    const submitButton = ref<HTMLButtonElement | null>(null);

    const changeStatus = async () => {
      consent_status.value = true;
      await store.dispatch(Actions.UPDATE_PATIENT_VALUE, { consent_sign: 1 });

      const [errorName] = Object.keys(store.getters.getErrors);
      const error = store.getters.getErrors[errorName];
      if (!error) {
        Swal.fire({
          text: t("Thank you!"),
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: t("Close"),
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      } else {
        Swal.fire({
          text: t(error[0]),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("Try again!"),
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
    };

    const updatevalue = Yup.object().shape({
      consent_sign: Yup.string()
        .required(t("Consent Sign is a required field"))
        .label(t("Consent Sign")),
    });

    const onSubmitValue = async (values) => {
      // Send request
      await store.dispatch(Actions.UPDATE_PATIENT_VALUE, values);

      const [errorName] = Object.keys(store.getters.getErrors);
      const error = store.getters.getErrors[errorName];
      if (!error) {
        Swal.fire({
          text: t("Thank you!"),
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: t("Close"),
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        });
      } else {
        Swal.fire({
          text: t(error[0]),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("Try again!"),
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
    };

    const currentDateTime = computed(() => {
      return Intl.DateTimeFormat(
        currentLocale.value === "en" ? "en-us" : currentLocale.value
      ).format(new Date());
    });

    return {
      item_current,
      item_complete,
      item_current_complete,
      active_class,
      patient_process_status,
      onSubmitValue,
      updatevalue,
      submitButton,
      changeStatus,
      isLoaded,
      consent_status,
      getPatientValues,
      patient_name,
      goToPage: (t) => {
        window.location.href = t;
      },
      currentDateTime,
    };
  },
});
